import { PayloadAction, createSlice } from '@reduxjs/toolkit';
// FIXME upper level import
import { CommonModalProps, ModalDictionary } from '../../app/shared/components/modalProvider/model';

export interface ModalQueueItem<N extends keyof ModalDictionary> {
  name: N;
  props?: CommonModalProps & ModalDictionary[N];
}

export interface ModalQueueState {
  items: ModalQueueItem<keyof ModalDictionary>[];
  iModalOpenedCount: number;
}

const initialState: ModalQueueState = {
  items: [],
  iModalOpenedCount: 0,
};
const reducerPath = 'modal-queue';

export const modalQueueSlice = createSlice({
  name: '@@app/modal/queue',
  initialState,
  reducers: {
    push(state, action: PayloadAction<ModalQueueItem<keyof ModalDictionary>>) {
      // ToDo: fix for multiple modals opening with same name and props
      let sequenceOfModalWithSameNameEnded = false;

      const items = state.items
        .slice()
        .reverse()
        .filter((item) => {
          if (sequenceOfModalWithSameNameEnded) {
            return true;
          }

          sequenceOfModalWithSameNameEnded = item.name !== action.payload.name;

          if (sequenceOfModalWithSameNameEnded) {
            return true;
          }

          return JSON.stringify(item.props) !== JSON.stringify(action.payload.props);
        })
        .reverse()
        .concat([action.payload]);

      return {
        ...state,
        items,
      };
    },
    shift(state): void {
      state.items.shift();
    },
    iModalCountChange: (state, action: PayloadAction<number>) => {
      state.iModalOpenedCount = action.payload;
    },
  },
});

export const reducerConfig = {
  [reducerPath]: modalQueueSlice.reducer,
};
export type ReducerStateShape = { [reducerPath]: ModalQueueState };

export const firstModalInQueueSelector = (state: ReducerStateShape) => state[reducerPath].items[0];

export const modalQueueLengthSelector = (state: ReducerStateShape) => state[reducerPath].items.length;
export const allProvidersOpenedModalCount = (state: ReducerStateShape) =>
  state[reducerPath].items.length + state[reducerPath].iModalOpenedCount;
